import { render, staticRenderFns } from "./twoToThree.vue?vue&type=template&id=064e994f&scoped=true&"
import script from "./twoToThree.vue?vue&type=script&lang=js&"
export * from "./twoToThree.vue?vue&type=script&lang=js&"
import style0 from "./twoToThree.vue?vue&type=style&index=0&id=064e994f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064e994f",
  null
  
)

export default component.exports